export enum SidebarLabel {
  Dashboard = 'dashboard',
  Dealboard = 'dealboard',
  Content = 'content',
  Library = 'library',
  Documents = 'documents',
  Contracts = 'contracts',
  Archive = 'archive',
  Reports = 'reports',
  Contacts = 'contacts',
  Products = 'products',
  Templates = 'templates',
  Rooms = 'rooms',
}
